import {Observable} from 'rxjs';
import {filter, map, withLatestFrom} from 'rxjs/operators';

import UiEventType            from '../../../../Ui/Shared/Constants/UiEventType';
import IUiEventsStreamPayload from '../../../../Ui/Shared/Interfaces/IUiEventsStreamPayload';
import Frame from '../Frame';

const createSettingsCloseTapStream = (
    uiEvents$: Observable<IUiEventsStreamPayload>,
    frameStoreUpdate$: Observable<Frame>
): Observable<void> =>
    uiEvents$
        .pipe(
            filter(({type}) =>
                type === UiEventType.SETTINGS_CLOSE_TAP ||
                type === UiEventType.FRAME_TAP),
            withLatestFrom(frameStoreUpdate$),
            filter(([, {isSettingsOpen}]) => isSettingsOpen),
            map(() => void 0)
        );

export default createSettingsCloseTapStream;